var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("h5", { staticClass: "text-h5 q-mt-lg q-mb-md" }, [
        _vm._v(_vm._s(_vm.$t(_vm.game_data.game_name)))
      ]),
      _c(
        "q-collapsible",
        {
          staticClass: "shadow-2 q-pa-sm q-ma-xs rounded-border",
          attrs: {
            icon: "far fa-ballot-check",
            "right-icon": "far fa-ballot-check",
            label: _vm.$t("how_to_create_the_game")
          }
        },
        [
          _c("div", { staticClass: "q-ma-sm" }, [
            _c("p", [_vm._v(_vm._s(_vm.$t("true_or_false_instructions")))]),
            _c("p", { staticClass: "q-mt-lg" }, [
              _c("em", [
                _c("strong", [_vm._v(_vm._s(_vm.$t("warning") + ": "))]),
                _vm._v(_vm._s(_vm.$t("create_game_before_save")))
              ])
            ])
          ])
        ]
      ),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-12 q-mb-md" }, [
          _c("div", { staticClass: "row gutter-sm" }, [
            _c(
              "div",
              { staticClass: "col-12" },
              [
                _vm.game_data.options.length
                  ? _c(
                      "q-list",
                      {
                        staticClass: "q-mt-md",
                        attrs: {
                          dense: "",
                          bordered: "",
                          padding: "",
                          separator: ""
                        }
                      },
                      _vm._l(_vm.game_data.options, function(option, index) {
                        return _c(
                          "q-item",
                          { key: index },
                          [
                            _c(
                              "q-item-main",
                              { staticClass: "q-mx-sm q-mt-sm row" },
                              [
                                _c(
                                  "q-field",
                                  {
                                    staticClass: " col q-px-sm",
                                    attrs: { count: 250 }
                                  },
                                  [
                                    _c("q-input", {
                                      attrs: {
                                        type: "textarea",
                                        rows: "1",
                                        "max-height": 250,
                                        "float-label": _vm.$t("phrase"),
                                        error:
                                          _vm.$v.game_data.options.$each[index]
                                            .question.text.$error
                                      },
                                      on: {
                                        change: function($event) {
                                          _vm.game_built
                                            ? _vm.resetGame()
                                            : null
                                        },
                                        input: function($event) {
                                          _vm.$v.game_data.options.$each[index]
                                            .question.text.$touch
                                        }
                                      },
                                      model: {
                                        value: option.question.text,
                                        callback: function($$v) {
                                          _vm.$set(option.question, "text", $$v)
                                        },
                                        expression: "option.question.text"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "q-field",
                                  { staticClass: "col-auto q-my-sm" },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "row justify-center" },
                                      [
                                        _c(
                                          "div",
                                          [
                                            _c("q-btn-toggle", {
                                              attrs: { options: _vm.selectors },
                                              model: {
                                                value: option.correct_choice,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    option,
                                                    "correct_choice",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "option.correct_choice"
                                              }
                                            }),
                                            option.question.length &&
                                            option.question.text.length
                                              ? _c("q-icon", {
                                                  staticClass: "q-mx-md",
                                                  attrs: {
                                                    name: "fal fa-check",
                                                    color: "positive"
                                                  }
                                                })
                                              : _vm._e(),
                                            _vm.game_data.options.length > 1
                                              ? _c(
                                                  "q-btn",
                                                  {
                                                    attrs: {
                                                      round: "",
                                                      flat: "",
                                                      color: "negative",
                                                      icon: "fal fa-trash"
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.removeWord(
                                                          index
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c("q-tooltip", [
                                                      _vm._v(
                                                        "\n\t\t\t\t\t\t\t\t\t\t\t\t\t" +
                                                          _vm._s(
                                                            _vm.$t("remove")
                                                          ) +
                                                          "\n\t\t\t\t\t\t\t\t\t\t\t\t"
                                                      )
                                                    ])
                                                  ],
                                                  1
                                                )
                                              : _vm._e()
                                          ],
                                          1
                                        )
                                      ]
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      }),
                      1
                    )
                  : _vm._e(),
                _c(
                  "div",
                  { staticClass: "col-xs-12 col-sm-4 q-mt-sm q-mx-xs" },
                  [
                    _c(
                      "q-field",
                      {
                        attrs: {
                          helper: _vm.$t(
                            "leave_it_blank_or_negative_to_use_infinite"
                          )
                        }
                      },
                      [
                        _c("q-input", {
                          attrs: {
                            type: "number",
                            "float-label": _vm.$t("alternative_error_limit")
                          },
                          on: {
                            change: function($event) {
                              _vm.game_built ? _vm.resetGame() : null
                            }
                          },
                          model: {
                            value: _vm.game_data.max_errors,
                            callback: function($$v) {
                              _vm.$set(_vm.game_data, "max_errors", $$v)
                            },
                            expression: "game_data.max_errors"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "row justify-end q-mr-md q-mt-md" },
                  [
                    _c("q-btn", {
                      staticClass: "q-mr-md",
                      attrs: {
                        color: "primary",
                        icon: "far fa-plus",
                        label: _vm.$t("add"),
                        disable: _vm.game_data.options.length > 9
                      },
                      on: { click: _vm.addOption }
                    }),
                    _c("q-btn", {
                      attrs: {
                        color: "secondary",
                        label: _vm.$t("preview"),
                        disable: _vm.disableGamePreview
                      },
                      on: { click: _vm.buildGamePreview }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ])
        ])
      ]),
      _vm.show_game_preview
        ? _c("true-or-false-preview", {
            attrs: {
              show_game_preview: _vm.show_game_preview,
              game_name: _vm.game_data.game_name,
              game_options: _vm.game_data.options,
              game_max_errors: _vm.game_data.max_errors,
              selectors: _vm.selectors
            },
            on: {
              hide_preview: function($event) {
                return _vm.hidePreview()
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }